import * as React from "react";
import classNames from "classnames";
import { WithStyles, withStyles, createStyles, Theme } from 'components/controls/styles';

export interface ErrorProps {
    noPadding?: boolean;
    noCenter?: boolean;
}

class Error extends React.PureComponent<ErrorProps & WithStyles<typeof styles>> {

    render() {
        const { classes, noPadding, noCenter } = this.props;

        const rootClass = classNames([
            { [classes.root]: true },
            { [classes.noPadding]: noPadding === true }
        ]);

        const contentClass = classNames([
            { [classes.content]: true },
            { [classes.center]: noCenter !== true }
        ])


        return <div className={rootClass}>
            <div className={contentClass} >
                {this.props.children}
            </div>
        </div>;
    }
}


const styles = (theme: Theme) => {

    return createStyles({

        root: {
            padding: theme.spacing.unit,
            position: 'relative',
            width: '100%',
            height: '100%',
        },

        noPadding: {
            padding: 0,
        },

        center: {
            textAlign: 'center',
        },

        content: {
            backgroundColor: theme.palette.error.main,
            color: theme.palette.error.contrastText,
            padding: theme.spacing.unit,
            position: 'relative',
        },
    })
}

export default withStyles(styles)(Error);
